import React, { Component } from 'react';
import Modal from 'react-modal';
import BuildSettings from '../../buildSettings';
import Analytics from 'APP_ROOT/services/analytics';
import Events from '../../common/events';
import lsUtil from '../../common/lsUtil';
import LambdaUtil from '../../aws/lambda/lambdaUtil';
import { strings } from '../../../localization';

export default class RavenInviteModal extends Component {

    constructor(props) {

        super(props);

        this.state = {
            isOpen: false, // is conditionally set to true in componentDidMount
            invite: false,
            errorMessage: undefined,
            errorCode: undefined // is used to differentiate errors during render to change the button names (RAV-3590)
        };
    }

    componentDidMount() {

        if (lsUtil.getLocalStorage()){

            const invite = this.getInvite();

            if(this.isValidInvite(invite)) {
                this.setState({
                    isOpen: true,
                    invite: invite
                });
            }    
        }
    }

    getInvite = () => {
        try{
            return JSON.parse(lsUtil.getLocalStorage().getItem('raven.invite'));
        }
        catch(e){
            console.error("profile: invalid invite", e);
            return null;
        }
    }

    isValidInvite(invite) {

            if (invite === null || invite === undefined) return false;

            if(invite.ignored) return false;

            if (!invite.token || !invite.signature || !invite.role || !invite.tag || !invite.accountId) return false;

            return true;
    }

    afterModalOpened = (e) => {
        Analytics.modalView('/ravenInviteModal');
    }

    closeModal = (e) => {

        e.preventDefault();
        document.documentElement.classList.remove("no-scroll");
        if (lsUtil.getLocalStorage()) {

            var invite = JSON.parse(lsUtil.getLocalStorage().getItem('raven.invite'));
            if (invite) {
                invite['ignored'] = true;
                lsUtil.getLocalStorage().setItem('raven.invite', JSON.stringify(invite));
            }
        }
        this.setState({
            isOpen: false
        });

        if(this.props.onSuccess) this.props.onSuccess();
    }

    onAcceptInvite = (e) => {
        const { invite } = this.state;
        const stage = this.props.user.stage || BuildSettings.environment();
        e.preventDefault();
        document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: strings.formatString(strings.invite_accepting_message, invite.role, invite.tag, invite.ownerName), override: true } }));
        LambdaUtil.acceptRavenInvitation(stage, invite.token, invite.signature, this.onAcceptInviteSuccess, this.onAcceptInviteFail);
    }

    onAcceptInviteSuccess = (data) => {

        var payload = JSON.parse(data.Payload);
        if (payload.status === 'ERROR') {
            if (payload.errorCode === 7000) {
                console.error(data);
                this.setState({
                    errorMessage: strings.formatString(strings.invite_accept_error_already_accepted),
                    errorCode: payload.errorCode
                });
            }
            else if (payload.errorCode === 2000) { // mismatched email error (RAV-2520)
                console.error(data);
                this.setState({
                    errorMessage: payload.message,
                    errorCode: payload.errorCode
                });
            } else {
                this.genericError(data);
            }
            document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
            return;
        } else {
            document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: strings.formatString(strings.invite_accepted_message), style: 'success', override: true } }));
            setTimeout(() => {
                if (lsUtil.getLocalStorage())
                    lsUtil.getLocalStorage().removeItem('raven.invite', null);
                if(this.props.onSuccess) this.props.onSuccess();
                else window.location.reload();
            }, 2000);
        }
    }

    onAcceptInviteFail = (data) => {

        this.genericError(data);
    }

    genericError(data) {

        if (data) console.error(data);
        this.setState({
            errorMessage: strings.formatString(strings.invite_accept_failed)
        }, () => {
            document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        });
    }

    render() {

        let leftButtonLabel = strings.app_close;
        let rightButtonLabel = strings.app_ok;
        if (this.state.errorMessage) {
            if (this.state.errorCode && this.state.errorCode === 2000) { // RAV-3590
                leftButtonLabel = strings.app_cancel;
                rightButtonLabel = strings.app_try_again;
            } else {
                leftButtonLabel = strings.app_ignore;
                rightButtonLabel = strings.app_accept;
            }
        }

        if (this.state.invite && this.state.invite.ownerName === this.props.currentUserEmail) {
            return (
                <Modal isOpen={this.state.isOpen}
                    contentLabel="raven-invitation-modal"
                    className="raven-invitation-modal react-modal-content react-modal-sm"
                    overlayClassName="react-modal-overlay"
                    shouldCloseOnOverlayClick={false}
                    onRequestClose={this.closeModal}
                    onAfterOpen={this.afterModalOpened}>
                    <div className="container-fluid form-card">
                        <h2><i className="material-icons red">close</i>{strings.formatString(strings.invite_accept_error_same_account)}</h2>
                        <div className="row">
                            <div className="col-12 action-btns text-right">
                                <button className="btn btn-outline-blue" onClick={this.closeModal}><i className="material-icons">close</i>{leftButtonLabel}</button>
                                <button className="btn" onClick={this.closeModal}><i className="material-icons">check</i>{rightButtonLabel}</button>
                            </div>
                        </div>
                    </div>
                </Modal>
            );
        } else if (this.state.invite) {
            const roleLabel = strings[`tags_role_${this.state.invite.role.toLowerCase()}_label`];
            return (
                <Modal isOpen={this.state.isOpen}
                    contentLabel="raven-invitation-modal"
                    className="raven-invitation-modal react-modal-content react-modal-sm"
                    overlayClassName="react-modal-overlay"
                    shouldCloseOnOverlayClick={false}
                    onRequestClose={this.closeModal}
                    onAfterOpen={this.afterModalOpened}>
                    <div className="container-fluid form-card">
                        <h2 className='text-center'><i className="material-icons">share</i>{strings.formatString(strings.invitation_title, <span className="blue">{this.state.invite.ownerName}</span>)}</h2>
                        <h2 className='text-center'>{strings.formatString(strings.invitation_access_level, <span className="blue">{roleLabel}</span>, <span className="blue">{this.state.invite.tag}</span>)}</h2>
                        <div className="row">
                            <div className="col-12 action-btns text-right">
                                <button className="btn btn-outline-blue" onClick={this.closeModal}><i className="material-icons">close</i>{leftButtonLabel}</button>
                                <button className="btn" onClick={this.onAcceptInvite}><i className="material-icons">check</i>{rightButtonLabel}</button>
                            </div>
                            <div className='col-12'>
                                {this.state.errorMessage ? <p className="error-message"><i className="material-icons">error_outline</i>{this.state.errorMessage}</p> : null}
                            </div>
                        </div>
                    </div>
                </Modal>
            );
        } else return null
    }
}
